import css from 'styled-jsx/css';

export default css`
  .breadcrumbs-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: 'Roboto-Medium';
    font-size: 16px;
    font-weight: 600;
  }
  @media (max-width: 767px) {
    .breadcrumbs-container {
      padding: 0;
      font-size: 10px;
    }
  }
  .breadcrumbs-title {
    display: block;
    padding: 10px;
  }
  .active-link {
    color: #a41c1c;
  }
  .overflow-hidden {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
